// extracted by mini-css-extract-plugin
export default {"digital":"Digital_digital__PDV2y"};